export default __webpack_public_path__ + "static/O0027-7eeb928dc2387e0bccf72df944a8ade0.png";